import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';

const separateEmphasisFromSubtitle = (subtitle) => {
  const strs = subtitle.split(' ');

  return [strs[0], strs.slice(1).join(' ')];
};

const Achievement = ({ icon, subtitle, title }) => {
  const [emphasis, subTitle] = separateEmphasisFromSubtitle(subtitle);

  return (
    <div className="w-full max-w-24 md:w-min md:max-w-min">
      {/* TODO: map new size to <Icon /> */}
      <Icon className="h-10 min-w-10 text-neutral-low-500" name={icon} />
      <Heading as="h3" className="mb-2 mt-4 text-neutral-low-500">
        {title}
      </Heading>
      <Heading className="text-neutral-low-500" size="size6">
        {emphasis}
        <br />
        {subTitle}
      </Heading>
    </div>
  );
};

Achievement.propTypes = {
  icon: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Achievement;
